import { DataUtilLocalStorage } from "../../../../data/utils/LocalStorage";

export class BubbleFieldStorage {
    private storageKey_: string | null = null;
    private lastPosition_: { [key: string]: { x: number, y: number } } = {}; // Para almacenar posiciones de burbujas entre sesiones

    constructor() { }

    public get _LastPosition() {
        return { ...this.lastPosition_ };
    }

    public get _StorageKey() {
        return this.storageKey_;
    }

    public set _StorageKey(storageKey: string | number) {
        this.storageKey_ = storageKey?.toString() || null;

        if (!this.storageKey_) {
            this.lastPosition_ = {};
            return;
        }

        const storageData = this._GetStorageData();
        if (storageData) {
            this.lastPosition_ = storageData;
        }
    }

    public _GetStorageDate(): string | null {
        const storageKey = this.storageKey_;
        if (!storageKey) return null;

        return DataUtilLocalStorage._GetItem('bubbleFieldStorageDate', `${storageKey}`);
    }

    public _GetStorageData(): { [key: string]: { x: number, y: number } } | null {
        const storageKey = this.storageKey_;
        if (!storageKey) return null;

        const data = DataUtilLocalStorage._GetItem('bubbleFieldBubblePositions', `${storageKey}`);
        const lastPosition = data ? JSON.parse(data) : null;

        return lastPosition;
    }

    public _SetStorageDate(date: string) {
        const storageKey = this.storageKey_;
        if (!storageKey) return;

        DataUtilLocalStorage._SetItem('bubbleFieldStorageDate', `${storageKey}`, date);
    }

    public _SetStorageData(positions: { [key: string]: { x: number, y: number } }) {
        const storageKey = this.storageKey_;
        if (!storageKey) return;

        for (const key in positions) {
            this.lastPosition_[key] = positions[key];
        }
        DataUtilLocalStorage._SetItem('bubbleFieldBubblePositions', `${storageKey}`, JSON.stringify(this.lastPosition_));
    }
}